// extracted by mini-css-extract-plugin
module.exports = {"suggestion-icon":"suggestion-icon___cTXRh"};